import { Box } from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import VixChart from 'components/implied_vol/Vix/VixChart';
import { useVixConfig } from 'hooks/iVol/useVixConfig';
import { VixProvider } from 'components/implied_vol/Vix';

export const Vix = () => {
  const isMobile = useIsMobile();
  // Vix config via nuqs URL state
  const [vixConfig, updateVixConfig] = useVixConfig();

  return (
    <Box
      sx={{
        width: isMobile ? '100vw' : '800px',
        height: isMobile ? '65vh' : '650px',
        alignSelf: 'flex-start',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <VixProvider config={vixConfig} onConfigChange={updateVixConfig}>
        <VixChart includeControlsWidget />
      </VixProvider>
    </Box>
  );
};
